import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Logo from './Logo';
import AccountPage from './AccountPage';
import apiClient from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api';

const MitraArea = () => {
  const navigate = useNavigate();
  const [activeBottomTab, setActiveBottomTab] = useState('home');
  const [showAccountPage, setShowAccountPage] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [userData, setUserData] = useState({
    full_name: 'Loading...',
    email: '',
    id: null
  });
  const [userLoading, setUserLoading] = useState(true);
  const [mitraId, setMitraId] = useState(null);
  const [produks, setProduks] = useState([]);
  const [produksLoading, setProduksLoading] = useState(true);
  const [artikels, setArtikels] = useState([]);
  const [artikelsLoading, setArtikelsLoading] = useState(true);
  const [mitraData, setMitraData] = useState({
    totalKeuntungan: 0,
    statusTernak: {
      sapi: {
        available: 0,
        booked: 0,
        sold: 0
      },
      kambing: {
        available: 0,
        booked: 0,
        sold: 0
      },
      domba: {
        available: 0,
        booked: 0,
        sold: 0
      }
    },
    loading: true
  });

  // Fetch user data dari API
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setUserLoading(true);
        // Coba ambil dari user_data di localStorage dulu (dari login response)
        const savedUserData = localStorage.getItem('user_data');
        if (savedUserData) {
          try {
            const parsed = JSON.parse(savedUserData);
            if (parsed.id) {
              // Fetch detail user dari API menggunakan user_id
              const response = await apiClient.get(API_ENDPOINTS.USER.GET_BY_ID(parsed.id));
              
              // Handle berbagai format response
              let userFromApi = null;
              if (response.data && response.data.user) {
                userFromApi = response.data.user;
              } else if (response.data && response.data.data) {
                userFromApi = response.data.data;
              } else if (response.data && !response.data.user) {
                userFromApi = response.data;
              } else if (!response.data) {
                userFromApi = response;
              }
              
              if (userFromApi) {
                setUserData({
                  full_name: userFromApi.full_name || parsed.full_name || 'Mitra',
                  email: userFromApi.email || parsed.email || '',
                  id: userFromApi.id || parsed.id
                });
                // Ambil mitra_id dari user data - cek berbagai kemungkinan field
                const mitraIdFromApi = userFromApi.mitra_id || userFromApi.id_mitra || userFromApi.mitra?.id || userFromApi.mitra_id_code;
                if (mitraIdFromApi) {
                  console.log('Mitra ID dari API user detail:', mitraIdFromApi);
                  setMitraId(mitraIdFromApi);
                } else {
                  // Jika tidak ada mitra_id, coba gunakan user.id sebagai fallback (jika format sesuai)
                  console.warn('Mitra ID tidak ditemukan di user data, mencoba fallback');
                }
              } else {
                // Fallback ke data dari localStorage
                setUserData({
                  full_name: parsed.full_name || 'Mitra',
                  email: parsed.email || '',
                  id: parsed.id
                });
                // Coba ambil mitra_id dari localStorage juga
                const mitraIdFromStorage = parsed.mitra_id || parsed.id_mitra || parsed.mitra?.id;
                if (mitraIdFromStorage) {
                  console.log('Mitra ID dari localStorage:', mitraIdFromStorage);
                  setMitraId(mitraIdFromStorage);
                }
              }
            } else {
              // Gunakan data dari localStorage
              setUserData({
                full_name: parsed.full_name || 'Mitra',
                email: parsed.email || '',
                id: parsed.id
              });
            }
          } catch (error) {
            console.error('Error fetching user by ID:', error);
            // Coba fetch dari /api/users/me
            try {
              const meResponse = await apiClient.get(API_ENDPOINTS.USER.GET_ME);
              if (meResponse.data && meResponse.data.data) {
                const userMe = meResponse.data.data;
                setUserData({
                  full_name: userMe.full_name || 'Mitra',
                  email: userMe.email || '',
                  id: userMe.id
                });
                // Ambil mitra_id dari user data - cek berbagai kemungkinan field
                const mitraIdFromMe = userMe.mitra_id || userMe.id_mitra || userMe.mitra?.id || userMe.mitra_id_code;
                if (mitraIdFromMe) {
                  console.log('Mitra ID dari /api/users/me:', mitraIdFromMe);
                  setMitraId(mitraIdFromMe);
                } else {
                  console.warn('Mitra ID tidak ditemukan di /api/users/me response');
                }
              }
            } catch (meError) {
              console.error('Error fetching user me:', meError);
              // Fallback ke data dari localStorage
              const parsed = JSON.parse(savedUserData);
              setUserData({
                full_name: parsed.full_name || 'Mitra',
                email: parsed.email || '',
                id: parsed.id
              });
            }
          }
        } else {
          // Jika tidak ada di localStorage, fetch dari /api/users/me
          const meResponse = await apiClient.get(API_ENDPOINTS.USER.GET_ME);
          if (meResponse.data && meResponse.data.data) {
            const userMe = meResponse.data.data;
            setUserData({
              full_name: userMe.full_name || 'Mitra',
              email: userMe.email || '',
              id: userMe.id
            });
            // Ambil mitra_id dari user data
            const mitraIdFromMe = userMe.mitra_id || userMe.id_mitra || userMe.mitra?.id || userMe.mitra_id_code;
            if (mitraIdFromMe) {
              console.log('Mitra ID dari /api/users/me (no localStorage):', mitraIdFromMe);
              setMitraId(mitraIdFromMe);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        // Fallback ke default
        setUserData({
          full_name: 'Mitra',
          email: '',
          id: null
        });
      } finally {
        setUserLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Fetch mitra data dari API berdasarkan user_id untuk mendapatkan mitra_id
  useEffect(() => {
    const fetchMitraData = async () => {
      // Tunggu sampai user data selesai di-fetch dulu
      if (userLoading || !userData.id) {
        return;
      }

      // Jika sudah ada mitra_id, tidak perlu fetch lagi
      if (mitraId) {
        return;
      }

      try {
        console.log('Fetching mitra data untuk user_id:', userData.id);
        
        // Hit endpoint /api/mitra/public/user/{user_id} untuk mendapatkan mitra_id
        const response = await apiClient.get(API_ENDPOINTS.MITRA.PUBLIC_BY_USER(userData.id));
        
        // Handle struktur response dari API
        let mitrasFromApi = [];
        if (response.data && response.data.mitras && Array.isArray(response.data.mitras)) {
          mitrasFromApi = response.data.mitras;
        } else if (response.data && Array.isArray(response.data)) {
          mitrasFromApi = response.data;
        } else if (response.mitras && Array.isArray(response.mitras)) {
          mitrasFromApi = response.mitras;
        }
        
        // Ambil mitra_id dari data.mitras[0].id
        if (mitrasFromApi.length > 0 && mitrasFromApi[0].id) {
          const fetchedMitraId = mitrasFromApi[0].id;
          console.log('Mitra ID ditemukan dari API:', fetchedMitraId);
          setMitraId(fetchedMitraId);
        } else {
          console.warn('Mitra tidak ditemukan untuk user_id:', userData.id);
        }
      } catch (error) {
        console.error('Error fetching mitra data:', error);
      }
    };

    fetchMitraData();
  }, [userLoading, userData.id, mitraId]);

  // Fetch produk dari API berdasarkan mitra_id
  useEffect(() => {
    const fetchProduks = async () => {
      // Tunggu sampai mitra_id sudah tersedia
      if (!mitraId) {
        return;
      }

      try {
        setProduksLoading(true);
        console.log('Fetching produk untuk mitra_id:', mitraId);
        
        // Fetch produk dari API
        const response = await apiClient.get(API_ENDPOINTS.MITRA.PUBLIC_PRODUK(mitraId, 10, 0));
        
        // Handle struktur response dari API
        let produksFromApi = [];
        if (response.data && response.data.produks && Array.isArray(response.data.produks)) {
          produksFromApi = response.data.produks;
        } else if (response.produks && Array.isArray(response.produks)) {
          produksFromApi = response.produks;
        }
        
        // Fetch images untuk setiap produk (jika ada endpoint images)
        const produksWithImages = await Promise.all(
          produksFromApi.map(async (produk) => {
            try {
              // Coba ambil images jika ada endpoint
              const imagesResponse = await apiClient.get(API_ENDPOINTS.PRODUK.PUBLIC_IMAGES(produk.id));
              let images = [];
              
              if (imagesResponse.data && imagesResponse.data.images) {
                images = imagesResponse.data.images;
              } else if (imagesResponse.images) {
                images = imagesResponse.images;
              } else if (Array.isArray(imagesResponse.data)) {
                images = imagesResponse.data;
              } else if (Array.isArray(imagesResponse)) {
                images = imagesResponse;
              }
              
              return {
                ...produk,
                images: images.length > 0 ? images : [],
                imageUrl: images.length > 0 ? images[0].url || images[0] : null
              };
            } catch (error) {
              // Jika tidak ada images endpoint atau error, gunakan image default
              console.error(`Error fetching images for produk ${produk.id}:`, error);
              return {
                ...produk,
                images: [],
                imageUrl: null
              };
            }
          })
        );
        
        setProduks(produksWithImages);
      } catch (error) {
        console.error('Error fetching produks:', error);
        setProduks([]);
      } finally {
        setProduksLoading(false);
      }
    };

    fetchProduks();
  }, [mitraId]);

  // Fetch artikel dari API untuk Peluang & Update
  useEffect(() => {
    const fetchArtikels = async () => {
      try {
        setArtikelsLoading(true);
        console.log('Fetching artikel untuk Peluang & Update...');
        
        // Fetch artikel dari API dengan limit 10 dan offset 0
        const response = await apiClient.get(`${API_ENDPOINTS.ARTIKEL.PUBLIC_LIST}?limit=10&offset=0`);
        
        // Handle struktur response dari API
        let artikelsFromApi = [];
        if (response.data && response.data.artikels && Array.isArray(response.data.artikels)) {
          artikelsFromApi = response.data.artikels;
        } else if (response.data && Array.isArray(response.data)) {
          artikelsFromApi = response.data;
        } else if (response.artikels && Array.isArray(response.artikels)) {
          artikelsFromApi = response.artikels;
        }
        
        setArtikels(artikelsFromApi);
      } catch (error) {
        console.error('Error fetching artikels:', error);
        setArtikels([]);
      } finally {
        setArtikelsLoading(false);
      }
    };

    fetchArtikels();
  }, []);

  // Fetch semua produk untuk menghitung total keuntungan dan status ternak
  useEffect(() => {
    const fetchAllProduksAndCalculate = async () => {
      if (!mitraId) {
        return;
      }

      try {
        setMitraData(prev => ({ ...prev, loading: true }));
        console.log('Fetching all produk untuk mitra_id:', mitraId);
        
        // Fetch semua produk dari API
        const response = await apiClient.get(API_ENDPOINTS.MITRA.PUBLIC_ALL_PRODUK(mitraId));
        
        // Handle struktur response dari API
        let allProduks = [];
        if (response.data && response.data.produks && Array.isArray(response.data.produks)) {
          allProduks = response.data.produks;
        } else if (response.produks && Array.isArray(response.produks)) {
          allProduks = response.produks;
        } else if (response.data && Array.isArray(response.data)) {
          allProduks = response.data;
        }
        
        // Hitung total keuntungan dari produk yang sold
        let totalKeuntungan = 0;
        allProduks.forEach((produk) => {
          // Hanya hitung produk yang is_sold = true dan harga_jual ada
          if (produk.is_sold && produk.harga_jual) {
            const hargaBeli = produk.harga_beli || 0;
            const hargaJual = produk.harga_jual || 0;
            const feeMarketing = produk.fee_marketing || 0;
            const percentProfit = produk.percent_profit || 0;
            
            // Keuntungan bersama = (harga_jual - harga_beli) - fee_marketing
            const keuntunganBersama = (hargaJual - hargaBeli) - feeMarketing;
            
            // Keuntungan investor = (percent_profit / 100) * keuntungan bersama
            const keuntunganInvestor = (percentProfit / 100) * keuntunganBersama;
            
            // Keuntungan mitra = keuntungan bersama - keuntungan investor
            const keuntunganMitra = keuntunganBersama - keuntunganInvestor;
            
            totalKeuntungan += keuntunganMitra;
          }
        });
        
        // Hitung status ternak berdasarkan jenis produk
        const statusTernak = {
          sapi: { available: 0, booked: 0, sold: 0, total: 0 },
          kambing: { available: 0, booked: 0, sold: 0, total: 0 },
          domba: { available: 0, booked: 0, sold: 0, total: 0 }
        };
        
        allProduks.forEach((produk) => {
          const jenisProduk = produk.jenis_produk_nama || '';
          const jenisLower = jenisProduk.toLowerCase();
          
          // Tentukan jenis ternak
          let jenisTernak = null;
          if (jenisLower.includes('sapi')) {
            jenisTernak = 'sapi';
          } else if (jenisLower.includes('kambing')) {
            jenisTernak = 'kambing';
          } else if (jenisLower.includes('domba')) {
            jenisTernak = 'domba';
          }
          
          if (jenisTernak) {
            // Hitung total produk per jenis
            statusTernak[jenisTernak].total += 1;
            
            // Available: is_available = true
            if (produk.is_available) {
              statusTernak[jenisTernak].available += 1;
            }
            
            // Booked: harga_jual ada dan is_sold = false
            if (produk.harga_jual && !produk.is_sold) {
              statusTernak[jenisTernak].booked += 1;
            }
            
            // Sold: harga_jual ada dan is_sold = true
            if (produk.harga_jual && produk.is_sold) {
              statusTernak[jenisTernak].sold += 1;
            }
          }
        });
        
        setMitraData({
          totalKeuntungan: totalKeuntungan,
          statusTernak: statusTernak,
          loading: false
        });
      } catch (error) {
        console.error('Error fetching all produks:', error);
        setMitraData(prev => ({ ...prev, loading: false }));
      }
    };

    fetchAllProduksAndCalculate();
  }, [mitraId]);

  // Fungsi logout
  const handleLogout = async () => {
    if (!window.confirm('Apakah Anda yakin ingin keluar?')) {
      return;
    }

    try {
      // Hit API logout
      await apiClient.post(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error) {
      console.error('Error calling logout API:', error);
      // Tetap lanjutkan proses logout meskipun API error
    } finally {
      // Hapus semua data dari localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('user_data');
      
      // Remove token dari apiClient
      apiClient.removeAuthToken();
      
      // Redirect ke halaman login
      window.location.href = '/login';
    }
    
    setShowUserDropdown(false);
  };

  // Effect untuk menutup dropdown ketika klik di luar
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserDropdown && !event.target.closest('.user-dropdown-container')) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserDropdown]);


  // Jika sedang menampilkan halaman akun
  if (showAccountPage) {
    return (
      <AccountPage 
        onBack={() => setShowAccountPage(false)}
        activeBottomTab={activeBottomTab}
        setActiveBottomTab={setActiveBottomTab}
        userData={userData}
      />
    );
  }

  return (
    <section id="mitra-area" className="min-h-screen bg-white">
      {/* Mobile Wrapper */}
      <div className="max-w-lg mx-auto bg-white shadow-2xl min-h-screen">
        
        {/* Header */}
        <header className="px-4 pt-8 pb-4 bg-white">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <div className="flex items-center space-x-2">
                <Logo size="small" showText={false} />
                <span className="font-bold text-primary">PAK MoO</span>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <div className="relative user-dropdown-container">
                <div 
                  className="flex items-center space-x-2 cursor-pointer hover:bg-gray-50 rounded-lg p-2 transition-colors"
                  onClick={() => setShowUserDropdown(!showUserDropdown)}
                >
                  <div className="text-right">
                    <p className="text-sm font-semibold text-primary">{userData.full_name}</p>
                    <p className="text-xs text-gray-500">{userData.email || 'Email tidak tersedia'}</p>
                  </div>
                  <div className="w-10 h-10 rounded-full border-2 border-accent bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                    <i className="fa-solid fa-user text-primary text-lg"></i>
                  </div>
                  <i className={`fa-solid fa-chevron-down text-gray-400 text-sm transition-transform ${showUserDropdown ? 'rotate-180' : ''}`}></i>
                </div>
                
                {/* Dropdown Menu */}
                {showUserDropdown && (
                  <div className="absolute right-0 top-full mt-2 w-64 bg-white rounded-xl shadow-2xl border border-gray-100 z-50">
                    <div className="p-4 border-b border-gray-100">
                      <div className="flex items-center space-x-3">
                        <div className="w-12 h-12 rounded-full border-2 border-accent bg-gradient-to-br from-primary/20 to-secondary/20 flex items-center justify-center">
                          <i className="fa-solid fa-user text-primary text-xl"></i>
                        </div>
                        <div>
                          <p className="font-semibold text-primary">{userData.full_name}</p>
                          <p className="text-xs text-gray-500">{userData.email || 'Email tidak tersedia'}</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-2">
                      <button 
                        className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors text-left"
                        onClick={() => {
                          setShowUserDropdown(false);
                          setActiveBottomTab('account');
                          setShowAccountPage(true);
                        }}
                      >
                        <i className="fa-solid fa-user-circle text-primary"></i>
                        <span className="font-medium text-gray-800">Lihat Profil</span>
                      </button>
                      
                      <button 
                        className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-gray-50 transition-colors text-left"
                        onClick={() => {
                          setShowUserDropdown(false);
                          window.open('/kontak', '_blank');
                        }}
                      >
                        <i className="fa-solid fa-question-circle text-primary"></i>
                        <span className="font-medium text-gray-800">Bantuan</span>
                      </button>
                      
                      <hr className="my-2 border-gray-100" />
                      
                      <button 
                        className="w-full flex items-center space-x-3 px-3 py-2 rounded-lg hover:bg-red-50 transition-colors text-left text-red-600"
                        onClick={handleLogout}
                      >
                        <i className="fa-solid fa-sign-out-alt"></i>
                        <span className="font-medium">Keluar</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="pb-32 bg-white">
          {/* Hero Carousel */}
          <section className="px-4 mt-4">
            <div className="relative rounded-2xl shadow-lg overflow-hidden h-[200px]">
              <div className="absolute inset-0 w-full h-full">
                <img className="w-full h-full object-cover" src="/sapi1.jpg" alt="Portal Mitra Ternak PAK MoO" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-primary/80 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <h2 className="text-white font-bold text-xl leading-tight">Portal Mitra Ternak</h2>
                <p className="text-gray-200 text-sm mt-1">Kelola investasi dan kemitraan ternak Anda.</p>
              </div>
            </div>
          </section>

          {/* Dashboard Cards */}
          <section className="px-4 mt-6 space-y-4">
            {/* Total Keuntungan */}
            <div className="bg-secondary rounded-2xl shadow-lg p-4 flex items-center justify-between text-white cursor-pointer hover:shadow-xl transition-shadow">
              <div className="flex items-center space-x-4">
                <div className="bg-accent/80 p-3 rounded-xl">
                  <i className="fa-solid fa-chart-line text-primary text-2xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold">Total Keuntungan</h4>
                  {mitraData.loading ? (
                    <>
                      <p className="text-2xl font-bold mt-1">...</p>
                      <p className="text-sm opacity-80">Memuat...</p>
                    </>
                  ) : (
                    <>
                      <p className="text-2xl font-bold mt-1">
                        {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(mitraData.totalKeuntungan)}
                      </p>
                      <p className="text-sm opacity-80">Akumulasi keuntungan</p>
                    </>
                  )}
                </div>
              </div>
              <i className="fa-solid fa-chevron-right text-accent text-3xl opacity-70"></i>
            </div>

            {/* Status Ternak - Sapi */}
            {mitraData.statusTernak.sapi?.total > 0 && (
              <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="bg-orange-100 p-3 rounded-xl mr-3">
                    <i className="fa-solid fa-cow text-orange-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 text-lg">Status Ternak Sapi</h4>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-check-circle text-green-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Available</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.sapi.available}</p>
                    <p className="text-xs text-gray-500">Siap jual</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-clock text-orange-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Booked</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.sapi.booked}</p>
                    <p className="text-xs text-gray-500">Dipesan</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-money-bill text-green-600 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Sold</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.sapi.sold}</p>
                    <p className="text-xs text-gray-500">Terjual</p>
                  </div>
                </div>
              </div>
            )}

            {/* Status Ternak - Kambing */}
            {mitraData.statusTernak.kambing?.total > 0 && (
              <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="bg-green-100 p-3 rounded-xl mr-3">
                    <i className="fa-solid fa-horse text-green-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 text-lg">Status Ternak Kambing</h4>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-check-circle text-green-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Available</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.kambing.available}</p>
                    <p className="text-xs text-gray-500">Siap jual</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-clock text-orange-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Booked</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.kambing.booked}</p>
                    <p className="text-xs text-gray-500">Dipesan</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-money-bill text-green-600 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Sold</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.kambing.sold}</p>
                    <p className="text-xs text-gray-500">Terjual</p>
                  </div>
                </div>
              </div>
            )}

            {/* Status Ternak - Domba */}
            {mitraData.statusTernak.domba?.total > 0 && (
              <div className="bg-white rounded-2xl shadow-lg p-4 border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="bg-blue-100 p-3 rounded-xl mr-3">
                    <i className="fa-solid fa-cloud text-blue-600 text-2xl"></i>
                  </div>
                  <h4 className="font-semibold text-gray-800 text-lg">Status Ternak Domba</h4>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-check-circle text-green-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Available</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.domba.available}</p>
                    <p className="text-xs text-gray-500">Siap jual</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-clock text-orange-500 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Booked</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.domba.booked}</p>
                    <p className="text-xs text-gray-500">Dipesan</p>
                  </div>
                  <div className="text-center bg-gray-50 rounded-xl p-4">
                    <div className="flex items-center justify-center mb-3">
                      <i className="fa-solid fa-money-bill text-green-600 text-lg mr-2"></i>
                      <span className="text-sm font-medium text-gray-600">Sold</span>
                    </div>
                    <p className="text-3xl font-bold text-gray-800 mb-1">{mitraData.statusTernak.domba.sold}</p>
                    <p className="text-xs text-gray-500">Terjual</p>
                  </div>
                </div>
              </div>
            )}
          </section>

          {/* Daftar Ternak Section */}
          <section className="px-4 mt-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-primary">Daftar Ternak</h3>
              <span 
                className="text-sm font-semibold text-accent cursor-pointer"
                onClick={() => window.location.href = '/daftar-ternak'}
              >
                Tampilkan Semua
              </span>
            </div>
            <div className="space-y-4">
              {produksLoading ? (
                // Loading state
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                  <p className="text-gray-500 text-sm mt-2">Memuat produk...</p>
                </div>
              ) : produks.length === 0 ? (
                // Empty state
                <div className="text-center py-8 bg-gray-50 rounded-2xl">
                  <i className="fa-solid fa-box-open text-4xl text-gray-300 mb-2"></i>
                  <p className="text-gray-500">Belum ada produk</p>
                </div>
              ) : (
                // List produk dari API
                produks.slice(0, 3).map((produk) => {
                  // Tentukan status berdasarkan is_available dan is_sold
                  let status = 'Available';
                  let statusColor = 'bg-green-500';
                  
                  if (produk.is_sold) {
                    status = 'Sold';
                    statusColor = 'bg-gray-500';
                  } else if (!produk.is_available) {
                    status = 'Booked';
                    statusColor = 'bg-orange-500';
                  }
                  
                  // Tentukan jenis produk untuk styling
                  const jenisProduk = produk.jenis_produk_nama || produk.nama_jenis_produk || 'Produk';
                  
                  // Ambil image atau gunakan default
                  const imageUrl = produk.imageUrl || '/sapi1.jpg';
                  
                  return (
                    <div 
                      key={produk.id} 
                      className="bg-white rounded-2xl shadow-lg p-4 flex items-center space-x-4 cursor-pointer hover:shadow-xl transition-shadow"
                      onClick={() => navigate(`/detail-investasi-sapi/${produk.id}`)}
                    >
                      <div className="relative">
                        <img 
                          className="w-24 h-24 object-cover rounded-xl" 
                          src={imageUrl} 
                          alt={produk.nama} 
                          onError={(e) => {
                            e.target.src = '/sapi1.jpg'; // Fallback image
                          }}
                        />
                        <span className={`absolute top-2 right-2 ${statusColor} text-white text-xs font-semibold px-2 py-1 rounded-full`}>
                          {status}
                        </span>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-center justify-between mb-1">
                          <h4 className="font-bold text-gray-800">{produk.nama}</h4>
                          <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
                            jenisProduk === 'Sapi' || jenisProduk.toLowerCase().includes('sapi') ? 'bg-orange-100 text-orange-600' :
                            jenisProduk === 'Kambing' || jenisProduk.toLowerCase().includes('kambing') ? 'bg-green-100 text-green-600' :
                            jenisProduk === 'Domba' || jenisProduk.toLowerCase().includes('domba') ? 'bg-blue-100 text-blue-600' :
                            'bg-gray-100 text-gray-600'
                          }`}>
                            {jenisProduk}
                          </span>
                        </div>
                        <p className="text-sm text-gray-600">Berat: {produk.target_bobot ? `${produk.target_bobot} kg` : '-'}</p>
                        <p className="text-xs text-gray-500 mt-1">Status: {status}</p>
                        {produk.harga_jual && (
                          <p className="text-xs font-semibold text-primary mt-1">
                            {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(produk.harga_jual)}
                          </p>
                        )}
                      </div>
                      <i className="fa-solid fa-chevron-right text-gray-400"></i>
                    </div>
                  );
                })
              )}
            </div>
          </section>

          {/* Peluang & Update Section */}
          <section className="px-4 mt-8">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-primary">Peluang & Update</h3>
              <span className="text-sm font-semibold text-accent cursor-pointer">
                Lihat Semua
              </span>
            </div>
            <div className="space-y-4">
              {artikelsLoading ? (
                // Loading state
                <div className="text-center py-8">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
                  <p className="text-gray-500 text-sm mt-2">Memuat artikel...</p>
                </div>
              ) : artikels.length === 0 ? (
                // Empty state
                <div className="text-center py-8 bg-gray-50 rounded-2xl">
                  <i className="fa-solid fa-newspaper text-4xl text-gray-300 mb-2"></i>
                  <p className="text-gray-500">Belum ada artikel</p>
                </div>
              ) : (
                // List artikel dari API
                artikels.slice(0, 2).map((artikel, index) => {
                  // Tentukan badge berdasarkan index atau kategori artikel
                  const isFirst = index === 0;
                  const badgeText = isFirst ? 'Peluang Baru' : 'Update';
                  const badgeClass = isFirst ? 'bg-green-100 text-green-600' : 'bg-blue-100 text-blue-600';
                  
                  // Ambil excerpt atau content truncated sebagai deskripsi
                  const description = artikel.excerpt || (artikel.content ? artikel.content.substring(0, 100) + '...' : 'Tidak ada deskripsi');
                  
                  // Image default atau dari artikel jika ada
                  const imageUrl = artikel.image || artikel.image_url || '/sapi2.jpg';
                  
                  return (
                    <div 
                      key={artikel.id} 
                      className="bg-white rounded-2xl shadow-lg p-3 flex items-center space-x-4 cursor-pointer hover:shadow-xl transition-shadow"
                      onClick={() => {
                        // Navigate ke detail artikel atau buka di tab baru
                        if (artikel.slug) {
                          window.open(`/artikel/${artikel.slug}`, '_blank');
                        } else {
                          window.open(`/artikel/${artikel.id}`, '_blank');
                        }
                      }}
                    >
                      <img 
                        className="w-20 h-20 object-cover rounded-xl" 
                        src={imageUrl} 
                        alt={artikel.title || 'Artikel'} 
                        onError={(e) => {
                          e.target.src = '/sapi2.jpg'; // Fallback image
                        }}
                      />
                      <div className="flex-1">
                        <span className={`text-xs ${badgeClass} font-semibold px-2 py-1 rounded-full`}>
                          {badgeText}
                        </span>
                        <h4 className="font-bold text-gray-800 mt-2">{artikel.title || 'Artikel'}</h4>
                        <p className="text-sm text-gray-500 mt-1">{description}</p>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </section>
          
          {/* Extra spacing for bottom navigation */}
          <div className="h-8"></div>
        </main>

        {/* Bottom Navigation */}
        <footer className="fixed bottom-0 left-0 right-0 max-w-lg mx-auto bg-white pt-2">
          <div className="bg-primary mx-4 mb-4 rounded-2xl shadow-lg">
            <div className="flex justify-around items-center h-20 text-white">
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'home' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('home');
                  window.location.href = '/member-area';
                }}
              >
                <i className="fa-solid fa-house text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Beranda</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'products' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('products');
                  window.open('/katalog', '_blank');
                }}
              >
                <i className="fa-solid fa-box-archive text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Katalog</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'landing' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('landing');
                  window.location.href = '/';
                }}
              >
                <i className="fa-solid fa-globe text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Pakmoo Web</span>
              </span>
              <span 
                className={`text-center flex flex-col items-center cursor-pointer ${activeBottomTab === 'account' ? 'text-accent' : 'opacity-70 hover:opacity-100'} transition`}
                onClick={() => {
                  setActiveBottomTab('account');
                  setShowAccountPage(true);
                }}
              >
                <i className="fa-solid fa-user-circle text-2xl"></i>
                <span className="text-xs font-semibold mt-1">Akun</span>
              </span>
            </div>
          </div>
        </footer>
      </div>
    </section>
  );
};

export default MitraArea;
